module.exports = __webpack_public_path__ + "img/import.19743b8d.svg";